import React from 'react';

const Countries = () => {
  const countries = [
    { name: 'India', flag: '🇮🇳', code: 'IN' },
    { name: 'Bahrain', flag: '🇧🇭', code: 'BH' },
    { name: 'Kuwait', flag: '🇰🇼', code: 'KW' },
    { name: 'Oman', flag: '🇴🇲', code: 'OM' },
    { name: 'Qatar', flag: '🇶🇦', code: 'QA' },
    { name: 'Saudi Arabia', flag: '🇸🇦', code: 'SA' },
    { name: 'United Arab Emirates (UAE)', flag: '🇦🇪', code: 'AE' }
  ];

  return (
    <>
    <hr className='border-gray-300 my-8'/>
    <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-3">Countries we serve</h2>
          <p className="text-gray-500 max-w-md mx-auto">
            Support CBSE-State Syllabus in India and the GCC.
          </p>
        </div>

    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      
      {countries.map((country, index) => (
        <div
          key={index}
          className="bg-white rounded-xl p-4 shadow-md hover:shadow-xl transition-all duration-300 text-center group cursor-pointer"
        >
          <div className="text-6xl mb-3 transform group-hover:scale-110 transition-transform duration-300">
            {country.flag}
          </div>
          <h3 className="font-semibold text-gray-800 text-sm md:text-base">
            {country.name}
          </h3>
          <p className="text-xs text-gray-500 mt-1">{country.code}</p>
        </div>
      ))}
    </div>
    <hr className='border-gray-300 my-8' />
    </>
  );
  
};

export default Countries;